import Vue from 'vue'
import Router from 'vue-router'
// import Index from './pages/index.vue'
const Index = resolve => require(['./pages/index'],resolve)
const Intro = resolve => require(['./pages/intro'],resolve)
const Business = resolve => require(['./pages/business'],resolve)
const Joinus = resolve => require(['./pages/joinus'],resolve)
const Activity = resolve => require(['./pages/activity'],resolve)

Vue.use(Router)

export default new Router({
  mode: 'history', //history
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/intro',
      name: 'intro',
      component: Intro
    },
    {
      path: '/business',
      name: 'Business',
      component: Business
    },
    {
      path: '/joinus',
      name: 'joinus',
      component: Joinus
    },
    {
      path: '/activity',
      component: Activity
    },
  ]
})
